import memoizeOne from 'memoize-one';
import {
	BASE_LEVEL_ITEM_HEIGHT,
	DEFAULT_ITEM_HEIGHT,
} from '@atlassian/timeline-table/common/constants';
import type { Item, ExpandedItems } from '@atlassian/timeline-table/common/types/item';

export const getTimelineTableItemsHeight = memoizeOne(
	(
		siblingItems: Item[] | undefined,
		expandedItems: ExpandedItems,
		rootItemHeight = DEFAULT_ITEM_HEIGHT,
		isRoot = true,
	): number =>
		(siblingItems || []).reduce(
			(sum, { childItems, id }) =>
				// if it is the root level, we want to add the height of the item
				(isRoot ? rootItemHeight : BASE_LEVEL_ITEM_HEIGHT()) +
				sum +
				(expandedItems[id]
					? getTimelineTableItemsHeight(childItems, expandedItems, rootItemHeight, false)
					: 0),
			0,
		),
);
